<template>
    <div>
                <a-card>
                    <a-form :form="form" class="custom pick-100 form-input about">
<!--                        <a-row>-->
<!--                            <a-col :span="24">-->
<!--                                <a-divider class="color-orange mt-6" orientation="left">项目信息</a-divider>-->
<!--                            </a-col>-->
<!--                            <table style="width:100%" class="fx-form">-->
<!--                                <tr>-->
<!--                                    <th>项目名称:</th>-->
<!--                                    <td>-->
<!--                                        <a-form-item>-->
<!--                                            <a-input-->
<!--                                                    size="large"-->
<!--                                                    style="color: black;font-weight: bold"-->
<!--                                                    disabled-->
<!--                                                    v-decorator="['supplierName',{initialValue:project.xmmc}]"-->
<!--                                            />-->
<!--                                        </a-form-item>-->
<!--                                    </td>-->
<!--                                    <th>项目编号:</th>-->
<!--                                    <td>-->
<!--                                        <a-form-item>-->
<!--                                            <a-input-->
<!--                                                    size="large"-->
<!--                                                    style="color: black;font-weight: bold"-->
<!--                                                    disabled-->
<!--                                                    v-decorator="['xmbh',{initialValue:project.wbbh?project.wbbh:project.xmbh}]"-->
<!--                                            />-->
<!--                                        </a-form-item>-->
<!--                                    </td>-->
<!--                                </tr>-->
<!--                            </table>-->
<!--                        </a-row>-->
                        <a-row>
                            <a-col :span="24">
                                <a-divider class="color-orange mt-6" orientation="left">需求调查响应文件上传</a-divider>
                            </a-col>
                            <table style="width:100%" class="fx-form">
                                <tr>
                                    <th class="not-null">文件上传:</th>
                                    <td>
                                        <a-form-item>
                                            <upload-selector :referId='xmid+supplier.id' ref="selector12"
                                                             :readonly="!isCommit"
                                                             configKey='supplier_survey_file'/>
                                        </a-form-item>
                                    </td>
                                </tr>
                            </table>
                        </a-row>
                        <a-row class="mt-6">
                            <a-col  style="text-align: center">
                                <a-button class="mt-4" type="primary"
                                          :disabled="!isCommit"
                                          @click="onSubmitCheck">{{xqDcInfo && xqDcInfo.commitStatus==='1'?'已提交':'提交'}}
                                </a-button>
                            </a-col>
                        </a-row>
                    </a-form>
                </a-card>
    </div>
</template>

<script>
    import qs from 'qs'
    import {PageView} from '@/layouts'
    import STable from '@/components/Table'
    import moment from 'moment'
    import 'vue-area-linkage/dist/index.css'
    import UploadSelector from "../../components/selector/UploadSelector";
    const uuidv4 = require('uuid/v4')

    export default {
        props:{
            xmid:{
                type:String,
                require:true
            }
        },
        created() {
            this.$nextTick(()=>{
                this.loadData()
            })

        },
        components: {
            PageView,
            STable,
            moment,
            UploadSelector,
        },
        name: 'DemanFile',
        data() {
            return {
                form: this.$form.createForm(this),
                supplier: {},
                project: {},
                xqDcInfo:{
                },
                isCommit:false

            }
        },
        methods: {
            loadData() {
                if (!this.xmid) {
                    this.error("项目ID数据异常!")
                    return;
                }
                let url = '/api/1/demandSign/getDemandProjectDetails.json?projectId=' + this.xmid
                this.$http.get(url).then(res => {
                    this.supplier = res.supplier
                    this.account = res.account
                    this.project = res.project
                    if (res.project.dcjzsj)
                    {
                        this.isCommit = moment().isBefore(res.project.dcjzsj)
                    }
                    if (res.xqDcInfo){
                        this.xqDcInfo = res.xqDcInfo
                    }
                })
            },
            error(val) {
                this.$error({
                    title: '提示',
                    content: val
                })
            },
            onSubmitCheck() {
                let that = this
                if (that.$refs.selector12.uploadFiles.length === 0) {
                    that.$error({
                        title: '提示',
                        content: '请先上传文件！！！'
                    })
                    return
                }
                that.$confirm({
                    title: '提交',
                    content: '是否确认提交？',
                    onOk() {
                        let url = '/api/v1/supplier/legalsign/onSubmitCheck.json?xmid=' + that.xmid+'&commitType=xqdc'
                        that.$http.get(url).then(res => {
                            if (res.code !== 200) {
                                that.$message.error("提交失败")
                                return
                            }
                            that.xqDcInfo = res.result
                            that.$message.success("提交成功")
                        })
                    }, onCancel() {
                        console.log("点击了取消")
                    }
                })
            },

        }
    }
</script>

<style lang="less" scoped>
    .step-form-style-desc {
        padding: 0 56px;
        color: rgba(0, 0, 0, .45);

        h3 {
            margin: 0 0 12px;
            color: rgba(0, 0, 0, .45);
            font-size: 16px;
            line-height: 32px;
        }

        h4 {
            margin: 0 0 4px;
            color: rgba(0, 0, 0, .45);
            font-size: 14px;
            line-height: 22px;
        }

        p {
            margin-top: 0;
            margin-bottom: 12px;
            line-height: 22px;
        }
    }

    /deep/ .ant-form-item-label label {
        color: #8c8c8c;
    }

    /deep/ .ant-form-item-children {
        color: #000;
        font-weight: bold;
    }

    .register-title {
        position: relative;
    }

    .register-title img {
        margin: auto;
    }

    .register-title p {
        position: absolute;
        top: 10px;
        font-size: 20px;
        color: #fff;
        width: 100%;
        text-align: center;
    }

    .ant-input {
        width: 100%;
    }

    th {
        width: 125px;
    }

    tr {
        height: 65px;
    }

    .ant-table-thead > tr > th {
        font-weight: bold;
    }
</style>
